import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DbTemplateService } from '../db-template.service';
import { ToastrService } from 'ngx-toastr';
import { DbTemplate, TemplateUsedIn } from '../db-template.model';
import { CommonService } from 'src/app/services/common.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-db-template-delete',
    templateUrl: './db-template-delete.component.html',
    styleUrl: './db-template-delete.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class DbTemplateDeleteComponent implements OnInit{

  @Input() DbTemplate!: DbTemplate;

  isLoading: boolean = true;
  loadingText: string = 'Undersøger..';
  templateUsedIn: TemplateUsedIn[] = [];  


  constructor(
    public activeModal: NgbActiveModal,
    private dbTemplateService: DbTemplateService,
    private toastrService: ToastrService,
    private commonService: CommonService

  ) {}

  async ngOnInit(): Promise<void> {

    this.templateUsedIn = await this.dbTemplateService.getdbTemplateUsedIn(this.DbTemplate.id);
    this.isLoading = false;

  }

  async onDelete()
  {
    if (this.templateUsedIn.length === 0) {
      await this.deleteTemplate();
    }
    else
    {
      this.commonService.confirm('Slet database skabelon', 'Bruger-skabeloner vil blive deaktiveret og kan ikke aktiveres igen! Fortsæt med at slette?', 'Ja', 'Nej','lg')
      .then(async (confirmed) => { 
        if (confirmed) {
            await this.deleteTemplate();
        }
      });
    }
  }

  async deleteTemplate(): Promise<void> {
    this.isLoading = true;
    this.loadingText = 'Sletter databaseskabelon';
    this.dbTemplateService.deleteDbTemplate(this.DbTemplate.id).then(() => {
      this.toastrService.success("Template slettet");
      this.commonService.DBTableAdded.emit();
      this.activeModal.close();          
    }).catch(() => {
      // HTTP-fejl vises globalt af GlobalErrorInterceptor/ErrorService
    }).finally(() => {
      this.isLoading = false;
    });
  }
}
